// ***** SHOP CUSTOM CONFIG START *****

export const CONFIG_HEADER = {
    hasNavigation: false,
    hasLanguages: false,
    hasLogo: true,
    hasTitle: true,
    hasContextMenu: true
}

export const CONFIG_LOGIN = {
    hasAgeConfirm: false,
    isFindIdLink: false,
    hasInfoText: false,
    hasUsernameConfirm: true
}

export const CONFIG_FOOTER = {
    hasAdditionalLinks: true
}

export const CONFIG_PAYMENT = {
    defaultPaymentProvider: 'hup',
    paymentProviders: {
        adyen: 'adyen',
        hup: 'hup'
    },
    isOpeningInNewTab: true
}

export const API = {
    url: 'https://test-teamtop-api.imperiax.org/'
};

export let ENV = 'test';
export let ENV_ADYEN = 'test';
export let ADYEN_RETURN_URL = 'https://test-teamtop.imperiax.org/checkout-result';
export let ADYEN_CLIENT_KEY = 'test_FESOQUDCKJC2XIPASSO3BQGY74PDQVG6';
export let SITE_URL = '//haou-members.6waves.com/';
// get the ENV from the .env file(because it has different env when building)
ENV = process.env.REACT_APP_ENV;
if (!ENV) {
    ENV = 'test';
}
if (ENV === 'dev') {
    // API.url = 'https://dev-teamtop2-api.imperiax.info/';
    API.url = 'https://haou-memberstest-api.6waves.com/';
    ADYEN_RETURN_URL = 'https://dev-teamtop2.imperiax.info/checkout-result';
    ADYEN_CLIENT_KEY = 'test_FESOQUDCKJC2XIPASSO3BQGY74PDQVG6';
    ENV_ADYEN = 'test';
}
if (ENV === 'test') {
    // API.url = 'https://test-teamtop-api.imperiax.org/';
    API.url = 'https://haou-memberstest-api.6waves.com/';
    ADYEN_RETURN_URL = 'https://test-teamtop.imperiax.org/checkout-result';
    ADYEN_CLIENT_KEY = 'test_FESOQUDCKJC2XIPASSO3BQGY74PDQVG6';
    ENV_ADYEN = 'test';
}
if (ENV === 'stagingTest') {
    API.url = '//haou-memberstest-api.6waves.com/';
    ADYEN_RETURN_URL = '//haou-memberstest.6waves.com/checkout-result';
    ADYEN_CLIENT_KEY = 'test_FESOQUDCKJC2XIPASSO3BQGY74PDQVG6';
    ENV_ADYEN = 'test';
    SITE_URL = '//haou-memberstest.6waves.com/';

}
if (ENV === 'stagingLive') {
    API.url = '//haou-memberstest-api.6waves.com/';
    ADYEN_RETURN_URL = '//haou-memberstest.6waves.com/checkout-result';
    ADYEN_CLIENT_KEY = 'live_WX6PVIYN6VDN7CZH2DWAGNG7QQUQLJXZ';
    ENV_ADYEN = 'live';
    SITE_URL = '//haou-memberstest.6waves.com/';
}
if (ENV === 'live') {
    API.url = '//haou-members-api.6waves.com/';
    ADYEN_RETURN_URL = '//haou-members.6waves.com/checkout-result';
    ADYEN_CLIENT_KEY = 'live_WX6PVIYN6VDN7CZH2DWAGNG7QQUQLJXZ';
    ENV_ADYEN = 'live';
    SITE_URL = '//haou-members.6waves.com/';
}

export const MOBILE_VIEW_BREAKPOINT = 1024;

export const MOBILE_VIEW_TABLET = 768;

export const DEFAULT_MENUS = [];

/**
 * Generates age options for the age confirmation dropdown (18-150)
 */
const getPossibleYears = () => {
    const minYears = 18;
    const maxYears = 150;
    const years = [];
    for (let i = minYears; i <= maxYears; i++) {
        years.push({value: i, label: i});
    }
    return years;
}

export const ageInputData = {
    years: getPossibleYears()
}

export const MIN_YEARS_TO_PURCHASE = 18;

export const TAX_INCLUDED_TEXT = '（税込）';

export const FREE_TEXT = '無料獲得';

export const NO_CAROUSEL_LAYOUT = 1;

export const SUPPORT_MAIL = 'sample@sample.com'

export const HAS_SEARCH_BAR = true;

export const HAS_CATEGORY_FILTER = false;

export const HAS_CATEGORY_NAVIGATION = true;

// ***** SHOP CUSTOM CONFIG END   *****
